import React, { Fragment, useEffect, useState } from 'react';

import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import styles from '../../App.module.css';
import useHttp from '../../hooks/use-http';
import { getApplicationSingle } from '../../lib/api';

const SubViewer = () => {

  const [gotResponse, setGotResponse] = useState( false );
  const { sendRequest, status, data: queryRes } = useHttp( getApplicationSingle );
  var data = [];

  useEffect( () => {
    sendRequest( { id: window.location.href.split( '/' ).at( -1 ) } );
  }, [sendRequest] );

  useEffect( () => {
    if ( status === 'completed' ) {
      console.log( 'setting true' );
      data = queryRes[0];

      setGotResponse( true );
    }
  }, [status, data] );

  return (
    <Card className={[styles['Card'], styles['larger-text']]}>
      <Card className={[styles['CardLvl2'], styles['bl']]}>
        {gotResponse && queryRes.map( ( data, idx ) => (
          <Card.Body key={idx} className={styles['flex-wrapper-vert']}>
            <Card.Body className={styles['flex-wrapper-between']}>
              <Link to="/">
                <Button type="button" className={styles['btn-round']}>To Home</Button>
              </Link>
              <Card.Title className={styles['page-header']}>Application #{data.id}</Card.Title>
              <Card.Title>{data.fundpathsec}</Card.Title>
            </Card.Body>
            <hr></hr>
            <Card.Title className={styles['sectionHeader']}>Full Proposal</Card.Title>
            <Card.Body className={styles['flex-wrapper']}>
              <Card.Title><a href={`${data.propfile_s}`} target="_blank" rel="noreferrer">{data.propfile_c}</a></Card.Title>
            </Card.Body>
            <hr></hr>
            <Card.Title className={styles['sectionHeader']}>Applicant Info</Card.Title>
            <Card.Body className={[styles['flex-wrapper-between']]}>
              <Card.Text>Name: {data.fname} {data.lname}, {data.degree}</Card.Text>
              <Card.Text>Email: <a href={`mailto:${data.email}`}>{data.email}</a></Card.Text>
            </Card.Body>
            <Card.Body className={[styles['flex-wrapper-between']]}>
              <Card.Text>Institution: {data.inst}</Card.Text>
              <Card.Text>Department: {data.department}</Card.Text>
              <Card.Text>Division: {data.division}</Card.Text>
            </Card.Body>
            <hr />
            {data.position === 'Faculty' ?
              (
                <Fragment>
                  <Card.Title className={styles['sectionHeader']}>Applicant is a {data.position} Member</Card.Title>
                  <Card.Body className={styles['flex-wrapper']}>
                    <Card.Text>Faculty Title: {data.facultytitle}</Card.Text>
                  </Card.Body>
                </Fragment> )
              : (
                <Fragment>
                  <Card.Title className={styles['sectionHeader']}>Applicant is a {data.position}</Card.Title>
                  <Card.Body className={styles['flex-wrapper-between']}>
                    <Card.Text>Fellowship Type: {data.fellowshipprogram}</Card.Text>
                    <Card.Text>Fellowship Year: {data.fellowshipyear}</Card.Text>
                    <Card.Text>Anticipated Completion Date: {data.fellowshipcompletion}</Card.Text>
                  </Card.Body>
                </Fragment>
              )}

            <hr></hr>
            <Card.Title className={styles['sectionHeader']}>Mentor Information</Card.Title>
            <Card.Body className={[styles['flex-wrapper-between']]}>
              <Card.Text>Name: {data.mentfname} {data.mentlname}, {data.mentdegree}</Card.Text>
              <Card.Text>Email: <a href={`mailto:${data.mentemail}`}>{data.mentemail}</a></Card.Text>
            </Card.Body>
            <Card.Body className={[styles['flex-wrapper-between']]}>
              <Card.Text>Institution: {data.mentinst}</Card.Text>
              <Card.Text>Department: {data.mentdepartment}</Card.Text>
              <Card.Text>Division: {data.mentdivision}</Card.Text>
            </Card.Body>
          </Card.Body>
        ) )}
      </Card>
    </Card>
  );
};

export default SubViewer;